import Model, { hasMany } from '@ember-data/model';
import type TagModel from './tag.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class Taggable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('tag', {
    async: false,
    inverse: 'taggable',
    as: 'taggable',
  })
  declare tags: TagModel[];

  [Type] = 'taggable' as const;
}
